export default class EventKey {
  // 实时查询事件
  static REAL_QUERY = 'onRealQuery'
}



// WEBPACK FOOTER //
// ./src/views/01Data-Overview/EventKey.js